// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1DHFn","header":"Messages_header__2nEqd"};